import { Link, NavLink } from 'react-router-dom';
import styles from '../../css/rulesAndPolicy.module.css'
import Bars from '../Bars';
import { FiArrowLeft } from 'react-icons/fi';

function Transparency() {
  
  return (

    <>

      <NavLink to="/info" className="backLink userSelectNone">
        <FiArrowLeft className="backIcon" />
        <span>Powrót</span>
      </NavLink>
    
      <div className={`${styles.rulesAndPolicyConteiner} userSelectNone`}>
        
        <h3>
          Transparentność platformy
        </h3>

        <p>GórskaPodwózka to prosta i otwarta platforma ogłoszeń, która dba o przejrzystość i uczciwość działania:</p>  

        <ul>
          <li>🔹 GórskaPodwózka nie wymaga logowania ani zakładania konta.</li>
          <li>🔹 GórskaPodwózka nie pobiera żadnych opłat ani prowizji – korzystanie jest całkowicie darmowe, natomiast użytkownik dobrowolnie może postawić "kawę" twórcy - na rozwój i opłaty płynące z utrzymania platformy ☕.</li>
          <li>🔹 GórskaPodwózka przetwarza wyłącznie dane podane dobrowolnie w ogłoszeniu i tylko w celu publikacji oraz umożliwienia kontaktu między użytkownikami.</li>
          <li>🔹 Ogłoszenia są sortowane wyłącznie chronologicznie – według daty dodania. Filtrowanie lub wyszukiwanie odbywa się na podstawie wybranych kryteriów, np. odległości.</li>
          <li>🔹 GórskaPodwózka nie stosuje algorytmów rankingujących ani systemów płatnej promocji.</li>
        </ul>

        <p style={{ marginTop: '4vh' }}>
          Celem serwisu jest ułatwienie wspólnych przejazdów lub wypraw w góry – w sposób prosty, niezależny i przejrzysty. 🏔️
        </p>

      </div>

      <p className={'mycopyright userSelectNone'} >
        © 2025 GórskaPodwózka — wszystkie prawa zastrzeżone. Autor: Mateusz
      </p>

      <Bars />

    </>
  
  );
}

export default Transparency;
